var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/item_name"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.805 17.07H17.26m-6.925-8.311L7.42 8.305l2.003 4.581 6.155-1.23V6.568l-2.201 1.509-2.08-1.975-.962 2.656ZM6.5 21.5h11a4 4 0 0 0 4-4v-11a4 4 0 0 0-4-4h-11a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemName);
export default __webpack_public_path__ + "static/media/item_name.ae789a23b7c0cf1007111b3a4320397e.svg";
export { ForwardRef as ReactComponent };